const CNET_CONSTRUCTOR_VECTOR_LAYER_STYLE = {
	'fill-color': 'rgba(0, 132, 255, 0.1)',
	'stroke-color': '#0099ff',
	'stroke-width': 2,
	'circle-radius': 7,
	'circle-fill-color': '#0099ff',
} as const;

const MEASURE_VECTOR_LAYER_STYLE = {
	'fill-color': 'rgba(255, 255, 255, 0.2)',
	'stroke-color': 'black',
	'stroke-width': 2,
	'circle-radius': 7,
	'circle-fill-color': 'black',
} as const;


export {
	CNET_CONSTRUCTOR_VECTOR_LAYER_STYLE,
	MEASURE_VECTOR_LAYER_STYLE,
};
